module.exports = "<div id=\"listSeeFullRedirectContainer--WrittenReviewsImage\" class=\"listSeeFullRedirectContainer\">\n    <div class=\"listSeeFullRedirectContainerText\">\n        <div id=\"listSeeFullRedirectContainerText--sub\">\n            List of All\n        </div>\n        <div id=\"listSeeFullRedirectContainerText--head\">\n            {{listAllType}}\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/ppeters/filmCritClient/src/app/components/listAllContentBox/listAllContentBox.component.html
// module id = ../../../../../src/app/components/listAllContentBox/listAllContentBox.component.html
// module chunks = main